/* ConsentsWrapper - Runs Consents if we're on Consents page. */
import * as Consents from "../../../output/Restaumatic.Site.Components.Consents/index.js";
function init() {
    const container = document.getElementById("ps-consents");
    if (!container)
        return; // not a Consents page (`/zgody-marketingowe`)
    const settings = {
        container: container,
        accountId: Skubacz.configuration.account_id,
        themeName: Skubacz.configuration.theme_name,
    };
    Consents.run(settings)();
}
export default {
    init,
};
